<template>
    <div>
                    <!-- Modal -->
            <div class="modal fade" :id="'vmbc_add'+ id" role="dialog">
                <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">{{servicename}}</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <div class="modal-body">
                        <div class="col-md-12 row">
                            <div class="col-md-6">
                                <input type="text" class="form-control mt-1" v-model="prices.serviceName" placeholder="name" required >
                            </div>
                            <div class="col-md-5">
                                <input type="number" class="form-control mt-1" v-model="prices.price" placeholder="price">
                            </div>
                            <div class="col-md-1">
                                <button type="button" class="btn btn-success" @click="addService()"><i class="fa fa-save"></i></button>
                            </div>
                        </div>

                        <div class="col-md-12 mt-2">
                            <table class="table table-condensed table-responsive-md">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Price</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(price, index) in servicePrice" :key="price.id">
                                        <td> <input type="text" v-model="price.serviceName" class="form-control"> </td>
                                        <td> <input type="number" v-model="price.price" class="form-control"> </td>
                                        <td> <button class="btn btn-danger btn-md" @click="deleteServicePrice(price.id , index)"><i class="fa fa-times"></i></button></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-success" @click="updateService"><i class="fa fa-edit"></i></button>
                    </div>
                </div>

                </div>
            </div>
    </div>
</template>

<script>
export default {
    props: ['id', 'servicename', 'servicePrice'],
    data() {
        return {
            prices: {
                id: '',
                classid: this.id,
                serviceName: null,
                user_id: this.$root.id,
                name: this.$root.staffname,
                price: 0.00
                },
        }
    },
    methods: {
        addService() {
            axios
            .get('./api/Service/Add', {
                params: this.prices
            })
            .then((result) => {
                console.log(result)
                this.servicePrice.push(result.data.data)
            }).catch((err) => {
                console.log(err)
            });
        },
        deleteServicePrice(id, index) {
            axios
            .get('./api/Service/Delete/'+id)
            .then((result) => {
                this.servicePrice.splice(index, 1)
            }).catch((err) => {
                console.log(err)
            });
        },
        updateService() {
            axios
            .post('./api/Service/Update/Price', {
                options: this.servicePrice,
                user_id: this.$root.id,
                name: this.$root.staffname
            })
            .then((result) => {
                $('.modal').modal('hide')
            }).catch((err) => {
                console.log(err)
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/Item/Service/Add.vue